export default "__VITE_ASSET__599b455c__"